import Sortable from 'sortablejs';

class ModuleLibrary {
	constructor() {
		this.content = document.querySelector('.page-content');
		this.sortable = Sortable.create(this.content);
		this.checkboxes = document.querySelectorAll('.module-library-menu__input');
		this.editModuleLink = document.querySelector('.module-library-menu__edit-module-link');
		this.moduleCount = Array.from(this.checkboxes).length;
		this.modulesShown = [];

		this.init();
	}

	init() {
		this.updateModulesShown();
		this.setEditLinkDisplay();

		this.checkboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
		});

		this.editModuleLink.addEventListener('click', this.handleEditModuleLink.bind(this));
	}

	handleCheckboxChange(e) {
		const { value, checked } = e.currentTarget;
		const blocks = document.querySelectorAll(`[data-module-id="${value}"]`);

		if (checked) {
			blocks.forEach((block) => {
				block.setAttribute('data-visible', 'true');
			});
		} else {
			blocks.forEach((block) => {
				block.setAttribute('data-visible', 'false');
			});
		}

		this.updateModulesShown();
		this.updateURL();
		this.setEditLinkDisplay();
	}

	updateModulesShown() {
		const modulesShown = [];
		const blocks = Array.from(this.content.children);
		blocks.forEach((block) => {
			if ('false' !== block.getAttribute('data-visible')) {
				modulesShown.push(block.getAttribute('data-module-id'));
			}
		});

		this.modulesShown = modulesShown.filter((v, i, a) => a.indexOf(v) === i);
	}

	updateURL() {
		const url = new URL(window.location.href);

		if (this.modulesShown.length === this.moduleCount) {
			url.searchParams.delete('modules');
		} else {
			url.searchParams.set('modules', this.modulesShown.join('-'));
		}

		if (url.search.length) {
			window.history.replaceState(null, null, url.search);
		} else {
			window.history.replaceState(null, null, url.href);
		}
	}

	setEditLinkDisplay() {
		this.editModuleLink.classList.toggle('active', this.modulesShown.length === 1);
	}

	handleEditModuleLink() {
		const moduleID = this.modulesShown[0];
		const url = window.ajaxurl.replace('admin-ajax.php', '');

		window.location.href = `${url}post.php?post=${moduleID}&action=edit`;
	}
}

new ModuleLibrary();
